module.exports = __webpack_public_path__ + "img/img-3-m-pass-plan@2x.520e90cd.png";